import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { MegaMenu } from '../../../../vtex-apps/mega-menu/default';
import { MegaMenuTriggerBtn } from '../../../../vtex-apps/mega-menu/defaultTrigger';

const StoreMenuDesktop = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'StoreMenuDesktop',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({ colSizing: 'auto', blockClass: 'menu-desk-2__row' }).props,
		childrenComponents: [
			FlexLayoutCol({ width: 'auto', blockClass: 'menu-desk-2__col' }, [
				MegaMenuTriggerBtn({ blockClass: 'menu-desk-2-mega-menu' }),
				MegaMenu({ blockClass: 'menu-desk-2-mega-menu' }),
			]),
			FlexLayoutCol({ width: 'grow' }, [
				Menu({
					blockClass: 'menu-desk-2__menu',
					items: [
						MenuItem({ id: 'menu-item-category-home-1' }).props,
						MenuItem({ id: 'menu-item-category-home-2', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-3', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-4', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-5', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-6', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-7', type: 'category' }).props,
						MenuItem({ id: 'menu-item-category-home-8' }).props,
					],
				}),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-desktop-2-menu-bg-color', name: 'Menu Background' },
			{ from: '--text-color-1-dark', to: '--menu-desktop-2-menu-text-color', name: 'Menu Text' },
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-categories-border-color',
				name: 'Megamenu Trigger Border',
			},
			//megamenu trigger bg
			{ from: '--white', to: '--menu-desktop-2-megamenu-trigger-bg-color', name: 'Megamenu Trigger Background' },
			//megamenu bg
			{ from: '--white', to: '--menu-desktop-2-megamenu-bg-color', name: 'Megamenu Background' },
			//megamenu text
			{ from: '--text-color-1-dark', to: '--menu-desktop-2-megamenu-text-color', name: 'Megamenu Trigger Text' },
			//mega menu header texr
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-megamenu-header-text-color',
				name: 'Megamenu Header Text',
			},
			//1st level color
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-mm-1st-level-text-color',
				name: 'Mega Menu 1st Level Text',
			},
			//1st level hover bg
			{
				from: '--neutral-color-high-medium',
				to: '--menu-desktop-2-mm-1st-level-bg-hover-color',
				name: 'Mega Menu 1st Level BG Hover',
			},
			//1st level heading
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-mm-1st-level-heading-color',
				name: 'Mega Menu 1st Level Heading',
			},
			//2nd level color
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-mm-2nd-level-text-color',
				name: 'Mega Menu 2nd Level Text',
			},
			//3rd level color
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-2-mm-3rd-level-text-color',
				name: 'Mega Menu 3rd Level Text',
			},
			//megamenu see more
			{ from: '--brand-color-primary-pure', to: '--menu-desktop-2-megamenu-see-more', name: 'Megamenu See More' },
			//text hover color
			{ from: '--text-color-1-light', to: '--menu-desktop-2-menu-text-hover-color', name: 'Menu Text Hover' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--menu-desktop-2-border-radius', name: 'Border Radius' },
			//megamenu trigger
			{ from: '--border-radius-none', to: '--menu-desktop-2-megamenu-trigger-br', name: 'Megamenu Trigger' },
			//megamenu
			{ from: '--border-radius-sm', to: '--menu-desktop-2-megamenu-br', name: 'Megamenu' },
		],
	},
	//borderWidth
	{
		type: 'borderWidth',
		list: [
			//megamenu
			{ from: '--border-width-none', to: '--menu-desktop-2-megamenu-border-width', name: 'Megamenu' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--menu-desktop-2-menu-fs', name: 'Trigger Size' },
			{ from: '--font-size-xs', to: '--menu-desktop-2-main-size', name: 'Main font Size' },
			//megamenu header
			{ from: '--font-size-sm', to: '--menu-desktop-2-megamenu-header-fs', name: 'Megamenu Header' },
			//1st level fs
			{ from: '--font-size-md', to: '--menu-desktop-2-mm-1st-level-fs', name: 'Mega Menu 1st Level' },
			//1st level heading fs
			{
				from: '--font-size-md',
				to: '--menu-desktop-2-mm-1st-level-heading-fs',
				name: 'Mega Menu 1st Level Heading',
			},
			//2nd level fs
			{ from: '--font-size-sm', to: '--menu-desktop-2-mm-2nd-level-fs', name: 'Mega Menu 2nd Level' },
			//megamenu see all
			{ from: '--font-size-xs', to: '--menu-desktop-2-megamenu-see-more-fs', name: 'Megamenu See More' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-desktop-2-megamenu-fw', name: 'Trigger weight' },
			{ from: '--font-weight-400', to: '--menu-desktop-2-menu-weight', name: 'Menu font weight' },
			//megamenu
			{ from: '--font-weight-700', to: '--menu-desktop-2-mm-title-fw', name: 'Mega Menu Title' },
			//1st level fw
			{ from: '--font-weight-700', to: '--menu-desktop-2-mm-1st-level-fw', name: 'Mega Menu 1st Level' },
			//1st level heading fw
			{
				from: '--font-weight-700',
				to: '--menu-desktop-2-mm-1st-level-heading-fw',
				name: 'Mega Menu 1st Level Heading',
			},
			//megamenu see all
			{ from: '--font-weight-400', to: '--menu-desktop-2-megamenu-see-more-fw', name: 'Megamenu See More' },
		],
	},
	{
		type: 'spacing',
		list: [
			//menu height
			{ from: '--spacing-nano', to: '--menu-desktop-2-menu-height', name: 'Menu Height' },
			//1st level gap
			{ from: '--spacing-nano', to: '--menu-desktop-2-mm-1st-level-gap', name: 'Mega Menu 1st Level Gap' },
			//2st level gap
			{ from: '--spacing-nano', to: '--menu-desktop-2-mm-2st-level-gap', name: 'Mega Menu 2st Level Gap' },
			//3rd level gap
			{ from: '--spacing-nano', to: '--menu-desktop-2-mm-3rd-level-gap', name: 'Mega Menu 3rd Level Gap' },
		],
	},
	//typography
	{
		type: 'typography',
		list: [
			//megamenu
			{ from: '--main-font', to: '--menu-desktop-2-menu-typography', name: 'Menu' },
			//megamenu typography
			{ from: '--main-font', to: '--menu-desktop-2-mm-typography', name: 'Mega Menu' },
		],
	},
];

export default StoreMenuDesktop;
